export default {
  placeholder: 'Select a status',
};
